export default "__VITE_ASSET__392a88e8__"